<button [disableRipple]="true" [matMenuTriggerFor]="menu" class="user-info flex" mat-button>
  <secure-avatar [avatarUrl]="currentUserPortraitUrl()" [title]="userName"></secure-avatar>
  <i class="navbar-profile-caret icon icon-caret"></i>
</button>
<mat-menu (closed)="menuClosed()" #menu="matMenu" class="context-menu" xPosition="before" yPosition="below">
  @if (user$ | async) {
    @if (user) {
      <span class="context-user-info flex" disableRipple mat-menu-item>
        <secure-avatar [avatarUrl]="currentUserPortraitUrl()" [title]="userName"></secure-avatar>
        <span class="menu-button-label user-name">{{ userName }}</span>
      </span>
    }
    <a
      [routerLink]="'/profile/details'"
      *authCan="personalDetailsFeature"
      class="button-personal-details-button"
      mat-menu-item
    >
      Personal details
    </a>
    @if (user) {
      <a (click)="openFeedbackDialog()" class="button-feedback-button" mat-menu-item>Send feedback</a>
    }
    <a (click)="logout()" class="button-logout-button" color="warn" mat-menu-item>Log out</a>
  }
</mat-menu>
